/* 필요 파일 import
import { $DKD, $GCD, $CD } from '@/confs/common.const';
import commonApi from "@/apis/common.api";
import gripUtil from "@/libs/grip.util";
*/

export default {
    state: {
        naverMaps: undefined,
        geoJsonDrawing: undefined,
        markerMap: {},
        selectedMarker: {},
        curInfoWindow: undefined,
        addongList: undefined,
        polygonMap: {},
        polylineMap: {},
        heatmapMap: {},
        circleMap: {},
        markerClustering: {},
        trafficLayer: undefined,
        cadastralLayer : undefined,
        recognizer: undefined,
    },
    getters: {
        getNaverMaps(state) {
            return state.naverMaps;
        },
        getGeoJsonDrawing(state) {
            return state.geoJsonDrawing;
        },
        getMarkerMap(state) {
            return state.markerMap;
        },
        getSelectedMarker(state) {
            return state.selectedMarker;
        },
        fetchedCurInfoWindow(state) {
            return state.curInfoWindow;
        },
        getAddongList(state) {
            return state.addongList;
        },
        getPolygonMap(state) {
            return state.polygonMap;
        },
        getPolylineMap(state) {
            return state.polylineMap;
        },
        getHeatmapMap(state) {
            return state.heatmapMap;
        },
        getCircleMap(state) {
            return state.circleMap;
        },
        getMarkerClustering(state) {
            return state.markerClustering;
        },
        getTrafficLayer(state) {
            return state.trafficLayer;
        },
        getCadastralLayer(state) {
            return state.cadastralLayer;
        },
        getRecognizer(state) {
            return state.recognizer;
        },
    },
    mutations: {
        NAVER_MAPS(state, naverMaps) {
            state.naverMaps = naverMaps;
        },
        GEO_JSON_DRAWING(state, geoJsonDrawing) {
            state.geoJsonDrawing = geoJsonDrawing;
        },
        MARKER_MAP(state, markerMap) {
            state.markerMap = markerMap;
        },
        SELECTED_MARKER(state, selectedMarker) {
            state.selectedMarker = selectedMarker;
        },
        CUR_INFO_WINDOW(state, curInfoWindow) {
            state.curInfoWindow = curInfoWindow;
        },
        ADDONG_LIST(state, addongList) {
            state.addongList = addongList;
        },
        POLYGON_MAP(state, polygonMap) {
            state.polygonMap = polygonMap;
        },
        POLYLINE_MAP(state, polylineMap) {
            state.polylineMap = polylineMap;
        },
        HEATMAP_MAP(state, heatmapMap) {
            state.heatmapMap = heatmapMap;
        },
        CIRCLE_MAP(state, circleMap) {
            state.circleMap = circleMap;
        },
        MARKER_CLUSTERING(state, markerClustering) {
            state.markerClustering = markerClustering;
        },
        TRAFFIC_LAYER(state, trafficLayer) {
            state.trafficLayer = trafficLayer;
        },
        CADASTRAL_LAYER(state, cadastralLayer) {
            state.cadastralLayer = cadastralLayer;
        },
        RECOGNIZER(state, recognizer) {
            state.recognizer = recognizer;
        },
    },
    actions: {
        SET_NAVER_MAPS(context, naverMaps) {
            context.commit("NAVER_MAPS", naverMaps);
        },
        SET_GEO_JSON_DRAWING(context, geoJsonDrawing) {
            context.commit("GEO_JSON_DRAWING", geoJsonDrawing);
        },
        SET_MARKER_MAP(context, markerMap) {
            context.commit("MARKER_MAP", markerMap);
        },
        SET_SELECTED_MARKER(context, selectedMarker) {
            context.commit("SELECTED_MARKER", selectedMarker);
        },
        SET_CUR_INFO_WINDOW(context, curInfoWindow) {
            context.commit("CUR_INFO_WINDOW", curInfoWindow);
        },
        SET_ADDONG_LIST(context, addongList) {
            context.commit("ADDONG_LIST", addongList);
        },
        SET_POLYGON_MAP(context, polygonMap) {
            context.commit("POLYGON_MAP", polygonMap);
        },
        SET_POLYLINE_MAP(context, polylineMap) {
            context.commit("POLYLINE_MAP", polylineMap);
        },
        SET_HEATMAP_MAP(context, heatmapMap) {
            context.commit("HEATMAP_MAP", heatmapMap);
        },
        SET_CIRCLE_MAP(context, circleMap) {
            context.commit("CIRCLE_MAP", circleMap);
        },
        SET_MARKER_CLUSTERING(context, markerClustering) {
            context.commit("MARKER_CLUSTERING", markerClustering);
        },
        SET_TRAFFIC_LAYER(context, trafficLayer) {
            context.commit("TRAFFIC_LAYER", trafficLayer);
        },
        SET_CADASTRAL_LAYER(context, cadastralLayer) {
            context.commit("CADASTRAL_LAYER", cadastralLayer);
        },
        SET_RECOGNIZER(context, recognizer) {
            context.commit("RECOGNIZER", recognizer);
        },
    }
};
